import { Component, Input, OnDestroy, OnInit, SecurityContext } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { LOCKED_IMG, CROSS } from 'src/defaultImages.js';
import { CollectionInfrastructureService } from 'src/app/collection-infrastructure/collection-infrastructure.service';
import { MessageService } from 'src/app/common/services/message.service';
import { LOCKED_FEATURE_TYPE } from '../../collection-infrastructure.enums';
import { CollectionInfrastructureHelperService } from '../../collection-infrastructure-helper.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-locked-feature',
  templateUrl: './locked-feature.component.html',
  styleUrls: ['./locked-feature.component.css'],
})
export class LockedFeatureComponent implements OnInit, OnDestroy {
  @Input() data: { type: number } = { type: LOCKED_FEATURE_TYPE.EXPIRED };
  isSubscription: number = 1;
  isNegative : boolean;
  images = {
    LOCKED_IMG,
    CROSS,
  };
  enums: any = {
    LOCKED_FEATURE_TYPE,
  };
  subHeader: string = '';
  subscription: Subscription = new Subscription();
  translationText: any;

  constructor(
    private _modalService: NzModalService,
    private _modalRef: NzModalRef,
    private _collectionInfraService: CollectionInfrastructureService,
    private _msgService: MessageService,
    private _ciHelperService: CollectionInfrastructureHelperService,
    private _translateService: TranslateService,
    private _sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.setTranslation();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  sanitizeHtml(html: string): SafeHtml {
    return this._sanitizer.sanitize(SecurityContext.HTML, html);
  }

  setTranslation(): void {
    this.subscription.add(
      this._translateService.get('SIDENAV').subscribe((translation) => {
        this.isNegative = this._ciHelperService.isNegativeBalance()
        this.translationText = translation;
        this.initializeContent();
      })
    );
  }

  initializeContent() {
    if (this.data.type === LOCKED_FEATURE_TYPE.EXPIRED) {
      this.subHeader = !this.isNegative ?  this.translationText.LOCKED_FEATURE_DESC_1 : this.translationText.LOCKED_FEATURE_DESC_3 ;
    } else if (this.data.type === LOCKED_FEATURE_TYPE.FREE_MENU_LEADS) {
      this.subHeader = this.translationText.LOCKED_FEATURE_DESC_2;
    }
  }

  renew() {
    this.cancelClicked();
    this._ciHelperService.redirectToSubscriptionPage();
  }

  async talkToExpert() {
    const { TalkExpertFormComponent } = await import(
      /* webpackPrefetch: true */ 'src/app/shared/shared modal/talk-expert-form/talk-expert-form.component'
    );
    this._modalService.create({
      nzClosable: false,
      nzContent: TalkExpertFormComponent,
      nzComponentParams: { subscription: !this.isNegative ? this.isSubscription : 0 },
      nzBodyStyle: { padding: '20px' },
      nzStyle: { top: '20px' },
      nzFooter: null,
      nzWidth: 500,
      nzMaskClosable: false,
    });
  }

  async upgrade() {
    const response: any = await this._collectionInfraService.upgrade();
    if ((response || {}).status) {
      this._msgService.showSuccess(this.translationText.THANK_YOU_UPGRADING);
    } else {
      this._msgService.showError(this.translationText.SOMETHING_WENT_WRONG);
    }
  }

  cancelClicked(): void {
    this._modalRef.close({ data: null, status: 0 });
  }
}
